import { render } from "./AppNavbarUser.vue?vue&type=template&id=352bd9ae"
import script from "./AppNavbarUser.vue?vue&type=script&lang=js"
export * from "./AppNavbarUser.vue?vue&type=script&lang=js"

import "./AppNavbarUser.vue?vue&type=style&index=0&id=352bd9ae&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__